import React from 'react';

export const Terms = () => {
  return (
    <div className="min-h-screen pt-32 pb-20">
      <div className="container mx-auto px-5 md:px-10">
        <div className="max-w-4xl mx-auto">
          <h1 className="heading-1 text-text-primary mb-6">TERMS OF USE</h1>
          <p className="body-small text-text-secondary mb-12">Last updated: {new Date().toLocaleDateString()}</p>

          <div className="space-y-8">
            <section>
              <h2 className="heading-4 text-text-primary mb-4">1. Agreement to Terms</h2>
              <p className="body-medium text-text-secondary mb-4">
                By accessing or using Opti Flo Apps Ltd's website and services, you agree to be bound by these Terms of Use. If you disagree with any part of these terms, you may not access our services.
              </p>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">2. Use License</h2>
              <p className="body-medium text-text-secondary mb-4">
                Permission is granted to temporarily access the materials on Opti Flo Apps Ltd's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
              </p>
              <ul className="space-y-2 ml-6">
                <li className="body-medium text-text-secondary">• Modify or copy the materials</li>
                <li className="body-medium text-text-secondary">• Use the materials for any commercial purpose or public display</li>
                <li className="body-medium text-text-secondary">• Attempt to decompile or reverse engineer any software</li>
                <li className="body-medium text-text-secondary">• Remove any copyright or proprietary notations</li>
                <li className="body-medium text-text-secondary">• Transfer the materials to another person or mirror the materials on any other server</li>
              </ul>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">3. Disclaimer</h2>
              <p className="body-medium text-text-secondary mb-4">
                The materials on Opti Flo Apps Ltd's website are provided on an 'as is' basis. Opti Flo Apps Ltd makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
              </p>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">4. Limitations</h2>
              <p className="body-medium text-text-secondary mb-4">
                In no event shall Opti Flo Apps Ltd or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Opti Flo Apps Ltd's website.
              </p>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">5. Accuracy of Materials</h2>
              <p className="body-medium text-text-secondary mb-4">
                The materials appearing on Opti Flo Apps Ltd's website could include technical, typographical, or photographic errors. Opti Flo Apps Ltd does not warrant that any of the materials on its website are accurate, complete, or current.
              </p>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">6. Links</h2>
              <p className="body-medium text-text-secondary mb-4">
                Opti Flo Apps Ltd has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Opti Flo Apps Ltd of the site. Use of any such linked website is at the user's own risk.
              </p>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">7. Modifications</h2>
              <p className="body-medium text-text-secondary mb-4">
                Opti Flo Apps Ltd may revise these terms of use at any time without notice. By using this website you are agreeing to be bound by the then current version of these Terms of Use.
              </p>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">8. Governing Law</h2>
              <p className="body-medium text-text-secondary mb-4">
                These terms and conditions are governed by and construed in accordance with the laws of the jurisdiction in which Opti Flo Apps Ltd operates.
              </p>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">9. Contact Information</h2>
              <p className="body-medium text-text-secondary mb-4">
                If you have any questions about these Terms of Use, please contact us:
              </p>
              <p className="body-medium text-text-primary">
                Email: <a href="mailto:contact@optiflo.app" className="text-brand-primary hover:underline">contact@optiflo.app</a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};